import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabaseRentalContractService } from '../../../../services/supabase/rental-contracts';
import type { RentalContractFormData } from '../../../../types/rental-contract';
import RentalContractModal from './RentalContractModal';

interface AddRentalContractModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddRentalContractModal({ 
  isOpen, 
  onClose, 
  onSuccess 
}: AddRentalContractModalProps) {
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async (formData: RentalContractFormData) => {
    setIsSubmitting(true);
    setError(null);
    
    try {
      await supabaseRentalContractService.create(formData);
      queryClient.invalidateQueries({ queryKey: ['rental-contracts'] });
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error adding rental contract:', err);
      setError(err instanceof Error ? err.message : 'Failed to add rental contract');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <RentalContractModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      title="Add Rental Contract"
    />
  );
}
